import { Directive, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { XMLValidator } from 'fast-xml-parser';
import { isEmpty } from 'lodash-es';

function validateXmlCode(xmlCode: string): string {
  const options = {
    ignoreAttributes: false, // Set to true if you want to ignore attributes
    ignoreNameSpace: true, // Set to true if you want to ignore XML namespaces
    allowBooleanAttributes: false, // Set to true if you want to allow boolean attributes
    parseNodeValue: true, // Set to true if you want to parse the text value of elements
    parseAttributeValue: false, // Set to true if you want to parse attribute values
    trimValues: true, // Set to true if you want to trim whitespace around values
  };

  const validationResult = XMLValidator.validate(xmlCode, options);

  if (validationResult !== true) {
    return validationResult.err.msg;
  }

  return null; // No error
}

function validateJsonCode(jsonCode: string): string {
  try {
    JSON.parse(jsonCode);
  } catch (error) {
    return error.message;
  }

  return null; // No error
}

export function datCodeValidator(mode: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let code = control.value;

    if (isEmpty(code)) {
      return null; // so we don't validate empty values
    }

    let validationResult;
    if (mode === 'xml') {
      validationResult = validateXmlCode(code);
    } else {
      validationResult = validateJsonCode(code);
    }

    return validationResult ? { codeError: validationResult } : null;
  };
}

@Directive({
  standalone: false,
  selector: '[datCodeValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: CodeValidatorDirective,
    multi: true
  }]
})
export class CodeValidatorDirective implements Validator, OnInit {
  @Input('datCodeValidator') mode: string;
  validatorFn: ValidatorFn;


  ngOnInit(): void {
    this.validatorFn = datCodeValidator(this.mode);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validatorFn?.(control);
  }
}